import React from "react";
import Marquee from "../components/brand/Marquee";
import Nav from "../components/brand/Nav";
import Footer from "../components/brand/Footer";
import PullQuote from "../components/brand/PullQuote";
import { MEDIA } from "../lib/media";
import { useScrollReveal } from "../lib/useScrollReveal";

const values = [
  { word: "QUALITY.", bg: "bg-navy", text: "text-bone" },
  { word: "COMMUNITY.", bg: "bg-red", text: "text-bone" },
  { word: "INDEPENDENCE.", bg: "bg-bone", text: "text-navy" },
];

const Story = () => {
  const pageRef = useScrollReveal();
  return (
    <div ref={pageRef} data-testid="page-story" className="bg-bone text-navy">
      <Marquee />
      <Nav />

      {/* HERO */}
      <section className="bg-bone text-navy pt-20 md:pt-28 pb-12 md:pb-20 relative">
        <div className="max-w-[1600px] mx-auto px-5 md:px-12">
          <p className="font-mono uppercase tracking-[0.3em] text-[10px] md:text-xs text-red mb-6">
            ◢◢ OUR STORY · CHAPTER 01
          </p>
          <h1
            data-testid="story-headline"
            className="font-display uppercase leading-[0.82] tracking-tighter text-[14vw] md:text-[11vw] lg:text-[10vw]"
          >
            WE STARTED WITH<br />
            <span className="text-red">ONE</span> CUP.
          </h1>
        </div>
      </section>

      {/* EDITORIAL */}
      <section className="bg-bone text-navy py-12 md:py-24">
        <div className="max-w-[1400px] mx-auto px-5 md:px-12 grid grid-cols-12 gap-8">
          {/* Year marker */}
          <div className="col-span-12 md:col-span-3">
            <p
              data-testid="story-year-marker"
              className="font-display text-red leading-none text-[20vw] md:text-[12vw]"
            >
              2026
            </p>
            <p className="font-mono uppercase tracking-[0.3em] text-[10px] mt-2 md:mt-4">
              FOUNDED · SAN FRANCISCO
            </p>
          </div>

          <div className="col-span-12 md:col-span-6 reveal">
            <p className="font-body text-lg md:text-xl leading-relaxed">
              Freedom Coffee started in a one-bedroom apartment with a beat-up
              espresso machine and the kind of optimism that gets you in
              trouble. We weren't trying to disrupt anything. We just wanted a
              cup that tasted like a Tuesday morning that didn't suck.
            </p>
            <p className="font-body text-lg md:text-xl leading-relaxed mt-6">
              One year later we opened the door on Polk Street. We hung a red
              awning, dialed in the roast, and told every regular by name. The
              line stretched out the door. It still does.
            </p>
          </div>

          <div className="col-span-12 md:col-span-3 reveal">
            <img
              src={MEDIA.main_street_bw}
              alt="Main street"
              className="w-full h-auto grain"
            />
            <p className="font-mono uppercase tracking-[0.25em] text-[10px] mt-2 text-navy/70">
              ◢ MAIN ST · DUSK
            </p>
          </div>
        </div>
      </section>

      {/* PULL QUOTE */}
      <section className="bg-red text-bone py-24 md:py-32 relative grain">
        <div className="max-w-[1600px] mx-auto px-5 md:px-12">
          <PullQuote>{`"WE'RE NOT A {{LIFESTYLE}}. WE'RE A LINE OUT THE DOOR ON A WEDNESDAY."`}</PullQuote>
          <p className="font-mono uppercase tracking-[0.3em] text-[10px] md:text-xs text-bone/80 mt-8">
            — THE FRDM CREW
          </p>
        </div>
      </section>

      {/* SECOND EDITORIAL */}
      <section className="bg-bone text-navy py-16 md:py-32">
        <div className="max-w-[1400px] mx-auto px-5 md:px-12 grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-5 reveal">
            <img
              src={MEDIA.coffee_beans}
              alt="Coffee beans"
              className="w-full h-auto grain"
            />
            <p className="font-mono uppercase tracking-[0.25em] text-[10px] mt-2 text-navy/70">
              ◢ SINGLE ORIGIN · ROASTED IN HOUSE
            </p>
          </div>

          <div className="col-span-12 md:col-span-7 reveal">
            <h2 className="font-display uppercase leading-[0.9] tracking-tight text-5xl md:text-7xl">
              What We're <span className="text-red">About.</span>
            </h2>
            <p className="font-body text-lg md:text-xl leading-relaxed mt-6">
              Coffee is the most American thing left that doesn't ask you to
              pick a side. It's a counter, a stool, a stranger, a sentence you
              didn't expect. We're not here to lecture you about beans. We're
              here to pour the cup, hand it over, and let you get on with it.
            </p>
            <p className="font-body text-lg md:text-xl leading-relaxed mt-5">
              No subscriptions. No app. No sermon. Just coffee that earns its
              keep.
            </p>
          </div>
        </div>
      </section>

      {/* VALUES BAND */}
      <section data-testid="story-values" className="bg-bone">
        {values.map((v, i) => (
          <div
            key={v.word}
            className={`${v.bg} ${v.text} py-14 md:py-20 border-t-4 border-navy reveal grain`}
            data-testid={`value-band-${i}`}
          >
            <div className="max-w-[1600px] mx-auto px-5 md:px-12 flex items-center justify-between gap-6">
              <h3 className="font-display uppercase leading-none tracking-tighter text-[14vw] md:text-[9vw]">
                {v.word}
              </h3>
              <p className="hidden md:block font-mono uppercase tracking-[0.3em] text-xs opacity-70 text-right">
                § VALUE
                <br />
                NO. 0{i + 1}
              </p>
            </div>
          </div>
        ))}
      </section>

      <Footer />
    </div>
  );
};

export default Story;
